import React, {useEffect} from 'react';
import {
    Layout, 
    message, 
    BackTop,
} from 'antd';
import MyHeader from './features/header/Header';
import MyContent from './features/content/Content';
import MyFooter from './features/footer/Footer';
import {useDispatch, useSelector} from 'react-redux';
import {loadUser} from './features/authentication/authenticationSlice';
import './App.less';
import {messageDuration} from "./features/content/setting_page/GeneralPanel/GeneralPanelSlice";
import {RootState} from "./app/store";
import {fcltDeptsThunks} from './features/fcltDeptSlice_static';


const App = () => {
    const dispatch = useDispatch();

    const {
        showSuccess: generalInfoSubmitSuccess,
        showFailure: generalInfoSubmitFailure,
    } = useSelector((state: RootState) => state.generalPanel);

    useEffect(() => {
        dispatch(loadUser());
        dispatch(fcltDeptsThunks.fetchFcltDepts());
    }, [dispatch]);

    useEffect(() => {
        if (generalInfoSubmitSuccess) {
            message.success('Update Success.', messageDuration);
        }
    }, [generalInfoSubmitSuccess, dispatch]);

    useEffect(() => {
        if (generalInfoSubmitFailure) {
            message.error('Update Failed.', messageDuration);
        }
    }, [generalInfoSubmitFailure, dispatch]);

    return (
        <Layout>
            <MyHeader />
            <MyContent />
            <MyFooter />
            <BackTop />
        </Layout>
    );
}

export default App;
